module.exports = fox._r("images/sd.png", __webpack_public_path__ + "images/sd.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/sd.png
// module id = 1100
// module chunks = 4